// auth modules
import axios from 'axios';
import Router from '../../router'
import { CHECK_TAKEN, LOGIN_URL, RESET_EMAIL_URL, SEND_VERIFICATION_CODE, SIGNUP_URL, RESET_PASSWORD, CUSTOMER_INFORMATION_URL, CHANGE_PASSWORD, BUSINESS_SIGNUP, GUEST_SIGNUP } from '../../api/url'
import moment from "moment";
import store from '../index';
// initial state
const state = {
  loginErrorMessage: '',
  resetEmailMessage: '',
  token: localStorage.getItem('token') || '',
  loggedIn: false,
  loggingIn: false,
  userDetails: {
    IsBusiness: null,
  },
  business: false,
  signUpModalOpen: false,
  businessRegistrationLoading: false,
  businessRegistrationSuccessful: false,
  businessRegistrationError: null,
  registered: false, 
  registering: false,
  customerInfoError: null,
  customerInfoLoading: false,
  customerInfoSuccess: false,
  guestSignUpLoading: false,
  guestSignUpSuccess: true,
  guestSignUpError: null,
}

function handleTokenTimeOut() {
  let now = moment(moment.now());
  let tokenExpiration = moment(moment.now()).add('25', 'days');
  let tokenExpirationDate = localStorage.getItem('tokenExpiration');
  if (tokenExpirationDate == null) {
    localStorage.setItem('tokenExpiration', tokenExpiration)
  } else {
    if (now.isSameOrAfter(tokenExpirationDate)) {
      localStorage.removeItem('tokenExpiration')  
      store.commit('auth/logout');    
    }
  }
}

function getHeaderWithToken() {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `JWT ${token}`,
  }
  return headers
}
// actions
const actions = {
  LoginRequest: ({ commit, dispatch }, data) => {
    commit('updateErrorMessage', null)
    commit('loggingIn');
    axios({url: LOGIN_URL, data, method: 'POST'})
    .then(res => {
      commit('updateToken', res.data.token);
      commit('updateLoginStatus', true);
      dispatch(`fetchCustomerInformation`, res.data.token);
      localStorage.setItem('token', res.data.token);
      // Commenting this line out for now, as the mounted api calls in Login overwrite some of the B2B api calls.
      // Router.push('/');
    })
    .catch(err => {
      if (err.response.data.non_field_errors) {
        commit('updateErrorMessage', err.response.data.non_field_errors[0]);
      } else {
        commit('updateErrorMessage', err);
      }
    })
  },
  mobileLoginRequest: ({ commit, dispatch }, data) => {
    commit('updateErrorMessage', null)
    commit('loggingIn');
    axios({url: LOGIN_URL, data, method: 'POST'})
    .then(res => {
      commit('updateToken', res.data.token);
      commit('updateLoginStatus', true);
      dispatch(`fetchCustomerInformation`, res.data.token);
      localStorage.setItem('token', res.data.token);
      Router.push('/');
    })
    .catch(err => {
      commit('updateErrorMessage', err);
    })
  },
  registerRequest: (context, data) => axios({ url: SIGNUP_URL, data, method: 'POST' }), 
  checkUsername: (context, data) => axios({ url: CHECK_TAKEN, data, method: 'POST' }),
  checkEmail: (context, data) => axios({ url: CHECK_TAKEN, data, method: 'POST' }),
  resetEmail: (context, data) => axios({ url: `${RESET_EMAIL_URL}${data}/`, method: 'POST' }),
  sentVerificationCode: (context, data) =>  axios({ url: `${SEND_VERIFICATION_CODE}${data.code}/`,data: {token: data.token}, method: 'POST' }),
  resetPassword: (context, data) => axios({ url: `${RESET_PASSWORD}`, data, method: 'POST' }),
  changePassword: (context, data) => axios({url: `${CHANGE_PASSWORD}`, data, method: 'POST', headers: getHeaderWithToken()}),
  async fetchCustomerInformation(context, tokken){
    const token = localStorage.getItem('token') || tokken
    const config = {
      method: 'get',
      url: CUSTOMER_INFORMATION_URL,
      headers: {
        Authorization: `JWT ${token}`,
      }
    };
    context.commit('customerInformationLoading')
    await axios(config) 
    .then((response) => {
      handleTokenTimeOut();
      context.commit('fetchCustomerInformation', response.data);
      context.commit('handleBusinessLogin', response.data.IsBusiness);
    }, (err) => {
      context.commit('customerInformationError', err)
    })
  },
  registerBusinessCustomer(context, data) {
    const config = {
      method: 'POST',
      url: BUSINESS_SIGNUP,
      data: data,
    };
    context.commit('businessRegisterLoading')
    axios(config)
    .then((response) => {
      context.commit('businessRegisterSuccessful', response.data);
    }, (err) => {
      context.commit('businessRegisterError', err.response.data);
    })
  },
  guestCheckout(context, data) {
    const config = {
      method: 'POST',
      url: GUEST_SIGNUP,
      data: data,
    };
    context.commit('guestSignUpLoading');
  return axios(config)
  }
};

// mutations
const mutations = {
  updateToken: (state, token) => {
    state.token = token
  },
  loggingIn(state, payload) {
    state.loggingIn = true;
    state.loggedIn = false;
  },
  updateErrorMessage: (state, message) => {
    if (message) {
      state.loginErrorMessage = message
    } else {
      state.loginErrorMessage = ""
    }
    state.loggingIn = false;
  },
  updateLoginStatus: (state, status) => {
    state.loggedIn = status;
    state.loggingIn = false;
  },
  logout: (state) => {
    state.loggedIn = false;
    state.token = '';
    state.userDetails = {};
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiration')  
    Router.push('/');
    location.reload();
  },
  customerInformationLoading(state, payload) {
    state.customerInfoLoading = true;
    state.userDetails = {};
    state.customerInfoError = null;
    state.customerInfoSuccess = false;
  },
  fetchCustomerInformation(state, payload) {
    state.customerInfoLoading = false;
    state.userDetails = payload;
    state.customerInfoError = null;
    state.customerInfoSuccess = true;
  },
  customerInformationError(state, payload) {
    state.customerInfoLoading = false;
    state.userDetails = {};
    state.customerInfoError = payload;
    state.customerInfoSuccess = false;
  },
  handleBusinessLogin(state, payload) {
   state.business = payload;
  },
  handleSignUpModal(state, payload) {
    state.signUpModalOpen = payload;
  },
  businessRegisterLoading(state, payload) {
    state.businessRegistrationLoading = true;
    state.businessRegistrationSuccessful = false;
    state.businessRegistrationError = null;
  },
  businessRegisterSuccessful(state, payload) {
    state.businessRegistrationLoading = false;
    state.businessRegistrationSuccessful = true;
    state.businessRegistrationError = null;
  },
  businessRegisterError(state, payload) {
    state.businessRegistrationLoading = false;
    state.businessRegistrationSuccessful = false;
    state.businessRegistrationError = payload;
  },
  registeringUser(state, payload) {
    state.registering = true;
    state.registered = false;
  },
  userRegistered(state, payload) {
    state.registering = false; 
    state.registered = true;
  },
  registerError(state, payload) {
    state.registering = false;
    state.registered = false;
  },
  guestSignUpLoading(state, payload) {
    state.guestSignUpLoading = true;
    state.guestSignUpSuccess = false;
    state.guestSignUpError = null;
  },
  guestSignUpSuccessful(state, payload) {
    state.guestSignUpLoading = false;
    state.guestSignUpSuccess = true;
    state.guestSignUpError = null;
  },
  guestSignUpFailure(state, payload) {
    state.guestSignUpLoading = false;
    state.guestSignUpSuccess = false;
    state.guestSignUpError = payload;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js